<template>
    <v-card-text class="narrow-container">
        <v-form @keyup.native.enter="onSubmit">
            <v-text-field
                v-model="form.email"
                :error-messages="form.$errors.email"
                label="Enter your email adress"
                outlined
                type="email"
                @blur="form.validate('email')"
                @input="delete form.$errors.email"
            />

            <div id="cf-turnstile" class="d-flex justify-center mb-5"></div>

            <v-row class="center">
                <v-col>
                    <v-btn
                        :loading="form.$busy"
                        block
                        color="primary"
                        depressed
                        large
                        rounded
                        @click="onSubmit"
                    >
                        Send email
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-card-text>

</template>

<script>
import * as rules from "vuelidate/lib/validators";
import cloudflareConfig from '@/assets/js/config/CloudFlare'

export default {
    name: "ForgotPassword",

    data() {
        return {
            loading: false,
            cf_turnstile_widget_id: null,
            form: new Form(this, 'form', {
                email: null,
                cf_turnstile_response: null,
            }),
        };
    },

    validations: {
        form: {
            email: {
                email: rules.email,
                required: rules.required
            },
            cf_turnstile_response: {
                required: rules.required
            }
        }
    },

    async mounted() {
        await this.$loadScript(cloudflareConfig.turnstile.scriptURL);
        this.cf_turnstile_widget_id = window.turnstile.render('#cf-turnstile', {
            ...cloudflareConfig.turnstile,
            action: 'Password-Reset',
            callback: token => {
                this.form.cf_turnstile_response = token
            },
        })
    },

    methods: {
        onSubmit() {
            if (!this.form.validate()) return;

            this.$apiService
                .post("password/email", this.form)
                .then(response => {
					window.turnstile.remove(this.cf_turnstile_widget_id);

					if (response.data?.google2fa_enable) {
                        this.$router.push({ name: 'ForgotPasswordWith2FA', params: { email: this.form.email } });
                    } else {
                        this.$router.push({ name: 'ForgotPassword.EmailSent' });
                    }
                })
                .catch(e => {
                    window.turnstile.reset(this.cf_turnstile_widget_id)
                })
        },
    }
};
</script>